import { createInvalidStateError } from '../factories/invalid-state-error';
import { CONTEXT_STORE } from '../globals';
export var getNativeContext = function getNativeContext(context) {
  var nativeContext = CONTEXT_STORE.get(context);

  if (nativeContext === undefined) {
    throw createInvalidStateError();
  }

  return nativeContext;
};